var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.68629 3.68629 1 7 1H13C16.3137 1 19 3.68629 19 7V13C19 16.3137 16.3137 19 13 19H7C3.68629 19 1 16.3137 1 13V7Z",
    fill: "#303261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11L9 13L14.5 7",
    stroke: "white",
    strokeWidth: 2.01011
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H13V0H7V2ZM18 7V13H20V7H18ZM13 18H7V20H13V18ZM2 13V7H0V13H2ZM7 18C4.23858 18 2 15.7614 2 13H0C0 16.866 3.13401 20 7 20V18ZM18 13C18 15.7614 15.7614 18 13 18V20C16.866 20 20 16.866 20 13H18ZM13 2C15.7614 2 18 4.23858 18 7H20C20 3.13401 16.866 0 13 0V2ZM7 0C3.13401 0 0 3.13401 0 7H2C2 4.23858 4.23858 2 7 2V0Z",
    fill: "#303261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.0e7935fe4843000ebed13a15ad01a450.svg";
export { ForwardRef as ReactComponent };